<script>
    export let frontImages;
    export let isFrontImageSelected;
    export let isImageHidden;
    export let onFrontImageClick;

    export let backImages;
    export let isBackImageSelected;
    export let onBackImageClick;
    export let showInstructions;

    export let selectedFrontImageId;
    export let selectedBackImageId;

    const cardSound = new Howl({
        src: ['sounds/card_sound_effect.mp3']
    });

    let falsySelectedFrontImageId = null;
    let falsySelectedBackImageId = null;

    $: disableFalsy =
        (!selectedFrontImageId && !selectedBackImageId) ||
        (selectedFrontImageId === selectedBackImageId);


    const onFrontMouseDown = (id) => {
        if(disableFalsy) {
            return;
        }
        if (id !== selectedFrontImageId && id !== selectedBackImageId) {
            falsySelectedFrontImageId = id;
        }
    };

    const onBackMouseDown = (id) => {
        if(disableFalsy) {
            return;
        }
        if (id !== selectedFrontImageId && id !== selectedBackImageId) {
            falsySelectedBackImageId = id;
        }
    };

    const onMouseUp = () => {
        falsySelectedFrontImageId = null;
        falsySelectedBackImageId = null;

    }
</script>

<div class="matching-scene-container">
    <div class="placeholder">
        <img
            class="tarto-box"
            src="images/extra_elements/tarto.png"
            alt=""
            title="játékszabály"
            on:click={() => showInstructions()}
        />
    </div>
    <div class="cards-container">
        <div class="card-row front">
            {#each frontImages as image}
                <div
                    class="selectable"
                    class:hidden="{isImageHidden(image.id)}"
                    on:mousedown={() => {
                        cardSound.play();
                        onFrontImageClick(image.id);
                        onFrontMouseDown(image.id);
                    }}
                    on:mouseup={() => onMouseUp()}
                >
                    <img
                        src={image.frontImgPath}
                        alt=""
                        class="image-thumbnail"
                        class:selected="{isFrontImageSelected(image.id)}"
                        class:falsySelection="{!selectedFrontImageId && selectedBackImageId && image.id === falsySelectedFrontImageId}"
                    />
                </div>
            {/each}
        </div>

        <div class="card-row back">
            {#each backImages as image}
                <div
                    class="selectable"
                    class:hidden="{isImageHidden(image.id)}"
                    on:mousedown={() => {
                        cardSound.play();
                        onBackImageClick(image.id);
                        onBackMouseDown(image.id);
                    }}
                    on:mouseup={() => onMouseUp()}
                >
                    <img
                        src={image.backImgPath}
                        alt=""
                        class="image-thumbnail"
                        class:selected="{isBackImageSelected(image.id)}"
                        class:falsySelection="{!selectedBackImageId && selectedFrontImageId && image.id === falsySelectedBackImageId}"
                    />
                </div>
            {/each}
        </div>
    </div>
</div>


<style>
    .matching-scene-container {
        display: flex;
        align-items: center;
    }
    .cards-container {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        width: 80%;
    }
    .card-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 32vh;
    }
    .selectable {
        cursor: pointer;
        text-align: center;
        width: 23vw;
        position: relative;
        z-index: 20;
    }

    .selectable:hover {
        position: relative;
        z-index: 30;
    }

    .card-row.back > .selectable:hover > .image-thumbnail {
        max-width: 23vw;
        width: 23vw;
        border-radius: 8%;
        margin: 0 -5vw;
    }

    .image-thumbnail.selected {
        border: solid 10px  #4682B4;
        border-radius: 13% !important;
    }

    .falsySelection {
        border-radius: 13% !important;
        border: solid 10px #A52A2A;
    }

    .card-row.back > .selectable:hover > :not(.selected).image-thumbnail {
        width: 23vw;
        border-radius: 8%;
    }
    
    .hidden {
        visibility: hidden;
    }
    .image-thumbnail {
        width: 11vw;
        border-radius: 8%;
    }
    .placeholder {
        width: 20%;
    }
    .tarto-box {
        transform: rotate(-90deg);
        height: 15vw;
        cursor: pointer;
    }
</style>